const HOME_PERSONAS = ['default', '1l', '2l3l', 'professor', 'undergrad'];

class HomePersonaTabs extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-persona-value]'));
    this.onClick = this.handleClick.bind(this);
    this.onKeydown = this.handleKeydown.bind(this);

    this.buttons.forEach(button => {
      button.addEventListener('click', this.onClick);
      button.addEventListener('keydown', this.onKeydown);
    });

    this.setPersona('default', { focus: false });
  }

  disconnectedCallback() {
    this.buttons?.forEach(button => {
      button.removeEventListener('click', this.onClick);
      button.removeEventListener('keydown', this.onKeydown);
    });
  }

  handleClick(event) {
    const value = event.currentTarget.dataset.personaValue;
    const next = document.documentElement.dataset.persona === value ? 'default' : value;
    this.setPersona(next, { focus: true });
  }

  handleKeydown(event) {
    const currentIndex = this.buttons.indexOf(event.currentTarget);

    if (currentIndex === -1) {
      return;
    }

    let nextIndex = null;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = (currentIndex + 1) % this.buttons.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = (currentIndex - 1 + this.buttons.length) % this.buttons.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = this.buttons.length - 1;
    }

    if (nextIndex === null) {
      return;
    }

    event.preventDefault();
    this.buttons[nextIndex].focus();
  }

  setPersona(persona, { focus } = {}) {
    const value = HOME_PERSONAS.includes(persona) ? persona : 'default';
    document.documentElement.dataset.persona = value;

    this.buttons.forEach(button => {
      const isActive = button.dataset.personaValue === value;
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      button.tabIndex = isActive ? 0 : -1;

      if (isActive && focus) {
        button.focus();
      }
    });

    if (!this.buttons.some(button => button.dataset.personaValue === value) && this.buttons[0]) {
      this.buttons[0].tabIndex = 0;
    }

    this.dispatchEvent(
      new CustomEvent('persona:change', {
        bubbles: true,
        detail: { persona: value },
      })
    );
  }
}

if (!customElements.get('home-persona-tabs')) {
  customElements.define('home-persona-tabs', HomePersonaTabs);
}

export default HomePersonaTabs;
